import axios from 'axios';

const [token] = ['token'].map(paramName => {
  const param = new URLSearchParams(window.location.search).get(paramName);
  if (!param) {
    // eslint-disable-next-line no-console
    return console.error(
      `Please provide a ${paramName} as a query parameter (?${paramName}=...) in order to use the application`
    );
  }
  return param;
});

export default class HttpService {
  constructor() {
    this.http = axios.create({
      baseURL: process.env.VUE_APP_API,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    // eslint-disable-next-line no-console
    this.onError = err => console.error(err);
  }
}
